import { useState } from 'react';
import { ScrollSync, ScrollSyncPane } from 'react-scroll-sync';

import SummaryEditElement from './Lessons/SummaryEditElement';

import { StyledSummaryElement } from '../../atoms/SummaryElement/StyledSummaryElement';
import { StyledContentElement } from '../../atoms/SettlementsDoneElement/StyledContentElement';
import { StyledHeading } from '../../atoms/SettlementsDoneElement/StyledHeading';
import { StyledHeadingCheckbox } from '../../atoms/SettlementsDoneElement/StyledHeadingCheckbox';
import { StyledText } from '../../atoms/Text/StyledText';
import {
    StyledArrow,
    StyledHeader,
    StyledHeaderElement,
    StyledDataWrapper,
} from '../../../styles/sharedStyles';
import { StyledDataWrapperContent } from '../../atoms/SummaryElement/StyledDataWrapperContent';

import { getLang, getLocale, getString } from '../../../strings';
import useScrollBar from '../../../logic/hooks/useScrollBar';
import { hasPermission } from '../../../logic/permissions';
import SummaryEditManagerHourElement from './ManagerHours/SummaryEditManagerHourElement';
import MonthSummary from './MonthSummary';

const SummaryElement = ({
    id,
    month,
    setMonth,
    students,
    trainers,
    managers,
    managerHourTypes,
    subjects,
    trigger,
    user,
    firstElement,
    onDelete,
    hours,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const { scrollElement, isScrollBar } = useScrollBar(false, true);

    const isAdmin = hasPermission(user, 'can_change_trainer_price_in_summary');

    const handleTrigger = () => {
        trigger?.();
        setIsOpen((val) => !val);
    };

    return (
        <StyledSummaryElement>
            <StyledContentElement isfirstchild={firstElement} isopen={isOpen}>
                <StyledHeading onClick={handleTrigger}>
                    <StyledText
                        hasdeclaredfontsize="22px"
                        hasdeclaredfontweight="700"
                        hasdeclaredtextalign="center"
                        hasdeclaredtexttransform="uppercase"
                        hasdeclaredfontcolor="#6786be"
                    >
                        {new Date(id).toLocaleDateString(getLocale(getLang()), {
                            month: 'long',
                            year: 'numeric',
                        })}
                    </StyledText>
                    <StyledHeadingCheckbox>
                        <StyledArrow isopen={isOpen} />
                    </StyledHeadingCheckbox>
                </StyledHeading>
                {isOpen && (
                    <StyledDataWrapper summarydata>
                        <ScrollSync>
                            <>
                                {month.lessons.length > 0 ? (
                                    <>
                                        <ScrollSyncPane>
                                            <StyledHeader
                                                hasalignself="flex-start"
                                                $isscrollbar={isScrollBar}
                                                ref={scrollElement}
                                                $isCheckbox={true}
                                                $secondDivMinWidth={900}
                                                $isCheckboxMinusWidth={104}
                                            >
                                                <div>
                                                    <StyledHeaderElement
                                                        $hasWidth={isAdmin ? '14.2%' : '16.6%'}
                                                    >
                                                        <StyledText
                                                            hasdeclaredfontsize="16px"
                                                            hasdeclaredfontweight="700"
                                                            hasdeclaredtextalign="center"
                                                            hasdeclaredlineheight="1.4em"
                                                        >
                                                            {getString('summary_element_uczen')}
                                                        </StyledText>
                                                    </StyledHeaderElement>
                                                    <StyledHeaderElement
                                                        $hasWidth={isAdmin ? '14.2%' : '16.6%'}
                                                    >
                                                        <StyledText
                                                            hasdeclaredfontsize="16px"
                                                            hasdeclaredfontweight="700"
                                                            hasdeclaredtextalign="center"
                                                            hasdeclaredlineheight="1.4em"
                                                        >
                                                            {getString('summary_element_data')}
                                                        </StyledText>
                                                    </StyledHeaderElement>
                                                    <StyledHeaderElement
                                                        $hasWidth={isAdmin ? '14.2%' : '16.6%'}
                                                    >
                                                        <StyledText
                                                            hasdeclaredfontsize="16px"
                                                            hasdeclaredfontweight="700"
                                                            hasdeclaredtextalign="center"
                                                            hasdeclaredlineheight="1.4em"
                                                        >
                                                            {getString('summary_element_godzin')}
                                                        </StyledText>
                                                    </StyledHeaderElement>
                                                    <StyledHeaderElement
                                                        $hasWidth={isAdmin ? '14.2%' : '16.6%'}
                                                    >
                                                        <StyledText
                                                            hasdeclaredfontsize="16px"
                                                            hasdeclaredfontweight="700"
                                                            hasdeclaredtextalign="center"
                                                            hasdeclaredlineheight="1.4em"
                                                        >
                                                            {getString('summary_element_przedmiot')}
                                                        </StyledText>
                                                    </StyledHeaderElement>
                                                    <StyledHeaderElement
                                                        $hasWidth={isAdmin ? '14.2%' : '16.6%'}
                                                    >
                                                        <StyledText
                                                            hasdeclaredfontsize="16px"
                                                            hasdeclaredfontweight="700"
                                                            hasdeclaredtextalign="center"
                                                            hasdeclaredlineheight="1.4em"
                                                        >
                                                            {getString('summary_element_trener')}
                                                        </StyledText>
                                                    </StyledHeaderElement>
                                                    <StyledHeaderElement
                                                        $hasWidth={isAdmin ? '14.2%' : '16.6%'}
                                                    >
                                                        <StyledText
                                                            hasdeclaredfontsize="16px"
                                                            hasdeclaredfontweight="700"
                                                            hasdeclaredtextalign="center"
                                                            hasdeclaredlineheight="1.4em"
                                                        >
                                                            {getString('summary_element_cena')}
                                                        </StyledText>
                                                    </StyledHeaderElement>
                                                    {isAdmin ? (
                                                        <StyledHeaderElement
                                                            $hasWidth={isAdmin ? '14.2%' : '16.6%'}
                                                        >
                                                            <StyledText
                                                                hasdeclaredfontsize="16px"
                                                                hasdeclaredfontweight="700"
                                                                hasdeclaredtextalign="center"
                                                                hasdeclaredlineheight="1.4em"
                                                            >
                                                                {getString(
                                                                    'summary_element_cena_tr'
                                                                )}
                                                            </StyledText>
                                                        </StyledHeaderElement>
                                                    ) : null}
                                                </div>
                                            </StyledHeader>
                                        </ScrollSyncPane>
                                        <StyledDataWrapperContent>
                                            {month.lessons.map((hour, idx) => (
                                                <SummaryEditElement
                                                    hour={hour}
                                                    key={idx + JSON.stringify(hour)}
                                                    setHour={(val) =>
                                                        setMonth((cur) => ({
                                                            ...cur,
                                                            lessons: cur.lessons.map((v, i) =>
                                                                i === idx
                                                                    ? typeof val === 'function'
                                                                        ? val(v)
                                                                        : val
                                                                    : v
                                                            ),
                                                        }))
                                                    }
                                                    deleteHour={() => {
                                                        setMonth((cur) => ({
                                                            ...cur,
                                                            lessons: cur.lessons.filter(
                                                                (_v, i) => i !== idx
                                                            ),
                                                        }));
                                                        onDelete();
                                                    }}
                                                    students={students}
                                                    trainers={trainers}
                                                    subjects={subjects}
                                                    isAdmin={isAdmin}
                                                />
                                            ))}
                                        </StyledDataWrapperContent>
                                    </>
                                ) : (
                                    <StyledText
                                        hasdeclaredfontsize="16px"
                                        hasdeclaredfontweight="700"
                                        hasdeclaredtextalign="center"
                                        hasdeclaredlineheight="1.4em"
                                    >
                                        {getString('summary_element_no_lessons')}
                                    </StyledText>
                                )}
                                {hasPermission(user, 'can_manage_all_manager_hours') && (
                                    <>
                                        <div style={{ width: '100%', marginTop: '20px' }}>
                                            <StyledText
                                                hasdeclaredfontsize="22px"
                                                hasdeclaredfontweight="700"
                                                hasdeclaredtextalign="center"
                                                hasdeclaredtexttransform="uppercase"
                                                hasdeclaredfontcolor="#6786BE"
                                            >
                                                {getString(
                                                    'UserPanelTrainerPay__manager_hours__title'
                                                )}
                                            </StyledText>
                                        </div>
                                        {month.managerHours.length > 0 ? (
                                            <>
                                                <ScrollSyncPane>
                                                    <StyledHeader
                                                        hasalignself="flex-start"
                                                        $isscrollbar={isScrollBar}
                                                        ref={scrollElement}
                                                        $isCheckbox={true}
                                                        $secondDivMinWidth={900}
                                                        $isCheckboxMinusWidth={104}
                                                    >
                                                        <div>
                                                            <StyledHeaderElement>
                                                                <StyledText
                                                                    hasdeclaredfontsize="16px"
                                                                    hasdeclaredfontweight="700"
                                                                    hasdeclaredtextalign="center"
                                                                    hasdeclaredlineheight="1.4em"
                                                                >
                                                                    {getString(
                                                                        'summary_element_manager_hour_type'
                                                                    )}
                                                                </StyledText>
                                                            </StyledHeaderElement>
                                                            <StyledHeaderElement>
                                                                <StyledText
                                                                    hasdeclaredfontsize="16px"
                                                                    hasdeclaredfontweight="700"
                                                                    hasdeclaredtextalign="center"
                                                                    hasdeclaredlineheight="1.4em"
                                                                >
                                                                    {getString(
                                                                        'summary_element_data'
                                                                    )}
                                                                </StyledText>
                                                            </StyledHeaderElement>
                                                            <StyledHeaderElement>
                                                                <StyledText
                                                                    hasdeclaredfontsize="16px"
                                                                    hasdeclaredfontweight="700"
                                                                    hasdeclaredtextalign="center"
                                                                    hasdeclaredlineheight="1.4em"
                                                                >
                                                                    {getString(
                                                                        'summary_element_godzin'
                                                                    )}
                                                                </StyledText>
                                                            </StyledHeaderElement>
                                                            <StyledHeaderElement>
                                                                <StyledText
                                                                    hasdeclaredfontsize="16px"
                                                                    hasdeclaredfontweight="700"
                                                                    hasdeclaredtextalign="center"
                                                                    hasdeclaredlineheight="1.4em"
                                                                >
                                                                    {getString(
                                                                        'summary_element_trener'
                                                                    )}
                                                                </StyledText>
                                                            </StyledHeaderElement>
                                                            <StyledHeaderElement>
                                                                <StyledText
                                                                    hasdeclaredfontsize="16px"
                                                                    hasdeclaredfontweight="700"
                                                                    hasdeclaredtextalign="center"
                                                                    hasdeclaredlineheight="1.4em"
                                                                >
                                                                    {getString(
                                                                        'summary_element_cena'
                                                                    )}
                                                                </StyledText>
                                                            </StyledHeaderElement>
                                                            <StyledHeaderElement>
                                                                <StyledText
                                                                    hasdeclaredfontsize="16px"
                                                                    hasdeclaredfontweight="700"
                                                                    hasdeclaredtextalign="center"
                                                                    hasdeclaredlineheight="1.4em"
                                                                >
                                                                    {getString(
                                                                        'summary_element_manager_hour_description'
                                                                    )}
                                                                </StyledText>
                                                            </StyledHeaderElement>
                                                        </div>
                                                    </StyledHeader>
                                                </ScrollSyncPane>
                                                <StyledDataWrapperContent>
                                                    {month.managerHours.map((hour, idx) => (
                                                        <SummaryEditManagerHourElement
                                                            hour={hour}
                                                            key={idx + JSON.stringify(hour)}
                                                            setHour={(val) =>
                                                                setMonth((cur) => ({
                                                                    ...cur,
                                                                    managerHours:
                                                                        cur.managerHours.map(
                                                                            (v, i) =>
                                                                                i === idx
                                                                                    ? typeof val ===
                                                                                      'function'
                                                                                        ? val(v)
                                                                                        : val
                                                                                    : v
                                                                        ),
                                                                }))
                                                            }
                                                            managers={managers}
                                                            managerHourTypes={managerHourTypes}
                                                            deleteHour={() => {
                                                                setMonth((cur) => ({
                                                                    ...cur,
                                                                    managerHours:
                                                                        cur.managerHours.filter(
                                                                            (v) => v.id !== hour.id
                                                                        ),
                                                                }));
                                                                onDelete();
                                                            }}
                                                        />
                                                    ))}
                                                </StyledDataWrapperContent>
                                            </>
                                        ) : (
                                            <StyledText
                                                hasdeclaredfontsize="16px"
                                                hasdeclaredfontweight="700"
                                                hasdeclaredtextalign="center"
                                                hasdeclaredlineheight="1.4em"
                                            >
                                                {getString('summary_element_no_manager_hours')}
                                            </StyledText>
                                        )}
                                    </>
                                )}
                            </>
                        </ScrollSync>
                        <MonthSummary val={month} hours={hours} currentKey={id} />
                    </StyledDataWrapper>
                )}
            </StyledContentElement>
        </StyledSummaryElement>
    );
};

export default SummaryElement;
